<script>
import { mapActions, mapGetters } from "vuex";
import { BaseInput, BaseIcon } from "@/components";
export default {
  name: "SearchCustomer",
  components: {
    BaseInput,
    BaseIcon,
  },
  data() {
    return {
      searchKey: "",
      error: null,
      isCustomerList: false,
      customerList: [],
    };
  },
  computed: {
    ...mapGetters(["customer"]),
    isDevMode() {
      let host = window.location.host;
      let subdomain = host.split(".")[0];
      if (subdomain == "veridagitimdev") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions(["searchCustomerBefore", "searchCustomer"]),
    search() {
      if (this.searchKey.length > 1) {
        this.searchCustomerBefore({ SearchValue: this.searchKey }).then(
          (res) => {
            if (!res || res?.error) {
              this.error = res.message ? res.message : "Bir hata oluştu..";
              this.isCustomerList = false;
            } else {
              this.error = null;
              this.isCustomerList = true;
              this.customerList = res.customers;
            }

            let host = window.location.host;
            let subdomain = host.split(".")[0];
            if (subdomain == "veridagitimdev") {
              let toastMessageForDevelopmentBranch =
                "accountStatusDescription: " +
                String(res.customers[0].accountStatusDescription) +
                "\n" +
                "isAutoBuyAndSellContract: " +
                String(res.customers[0].isAutoBuyAndSellContract);
              this.$toast.warning(toastMessageForDevelopmentBranch);
            }
          }
        );
      }
    },
    searchCustomerDetail(customerNo) {
      this.searchCustomer({ customerNo: customerNo }).then((res) => {
        if (!res || res?.error) {
          this.error = res.message ? res.message : "Bir hata oluştu..";
          this.isCustomerList = false;
        } else {
          this.error = null;

          this.$router.push({
            name: "CustomerDetail",
            params: {
              customerId: res.id,
              customerNumber: customerNo,
            },
          });
        }
      });
    },
    clearError() {
      this.error = null;
    },
  },
};
</script>
<template>
  <div class="search-customer">
    <div v-if="isDevMode">testing-cache-version: 1.1.2</div>
    <base-input
      @enter="search()"
      inputType="text"
      labelText="Aramak istediğiniz müşteriyi girin ENTER tuşuna basın"
      id="username"
      placeholder="Müşteri ara..."
      v-model="searchKey"
      :withIcon="false"
    />
    <div class="btn-search" @click.prevent="search()">
      <base-icon :name="'search'"></base-icon>
    </div>
    <div class="search-customer__list" v-show="isCustomerList">
      <div
        class="search-customer__list-item"
        v-for="item in customerList"
        :key="item.customerNo"
        @click="searchCustomerDetail(item.customerNo)"
      >
        {{ item.name }} {{ item.surname }}
        <span> ({{ item.customerNo }}) </span>
      </div>
    </div>
    <div class="search-customer__error" v-show="error">
      {{ error }}
      <span id="clearError" @click="clearError">x</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.search-customer {
  position: relative;
  max-width: 668px;
  margin: auto;
  text-align: center;
  @media (max-width: 685px) {
    width: 95%;
  }
  .btn-search {
    width: 40px;
    height: 40px;
    padding-top: 7px;
    box-sizing: border-box;
    position: absolute;
    top: 32px;
    right: 10px;
    cursor: pointer;
    opacity: 0.8;
    @media (max-width: 357px) {
      padding-top: 22px;
    }
  }
  &__list {
    border: transparent;
    color: var(--grayscale-90);
    border-radius: var(--radius-first);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    max-height: 165px;
    overflow: auto;

    &-item {
      border-bottom: 1px solid var(--grayscale-20);
      padding: 15px 10px;
      text-align: left;
      cursor: pointer;
    }
  }

  &__error {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    padding: 20px 10px;
    color: #a0323c;
    background-color: var(--color-accent);
    text-align: left;
    margin-top: 20px;
    border-radius: var(--radius-first);
    border: solid 1px rgba(180, 169, 170, 0.1);

    span {
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
